import React, { useState, lazy, } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { 
  Header,
  Contact,
    Privacy,
    Services,
    Review,
  Refund, 
   Terms,
  Footer,
} from './components';

import ServiceDetail from "./pages/ServiceDetail";

const Error = lazy(() => import('./pages/Error'));
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));


function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="App">
      <BrowserRouter>
        <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        <main className="main-content">
          
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/service/:id" element={<ServiceDetail />} />
            <Route path="*" element={<Error />} />
             <Route path="/contact" element={<Contact />} />
             
             <Route path="/review" element={ <  Review />} />
              <Route path="/about" element={<About />} />
             <Route path="/services" element={<Services />} />
          
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/refund-and-cancellation-policy" element={<Refund />} />
            
            </Routes>
          
        </main>

        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;